export function inBrowser(): boolean {
  try {
    Boolean(window)
  } catch {
    return false
  }

  return true
}
